<template>
  <Message v-if="validationError" :closeable="false" severity="error">{{ validationError }}</Message>
  <div class="mt-2">
    <Select name="action" :options="props.contact.actions" optionLabel="label" v-model="action" :placeholder="'Select an Action'"> </Select>
  </div>
  <div>
    <p>Please enter any comments you wish to be included in the email.</p>
    <Textarea v-model="message" class="w-full" rows="10" auto-resize></Textarea>
  </div>
  <div class="mt-2">
    <Button v-if="sending" label="Send Email" type="submit" icon="pi pi-spinner pi-spin" iconPos="right" disabled />
    <Button v-else-if="action != undefined" label="Send Email" type="submit" icon="pi pi-send" iconPos="right" @click="checkAndSendEmail" />
    <Button v-else label="Send Email" type="submit" icon="pi pi-send" iconPos="right" disabled />
  </div>
</template>

<script setup lang="ts">
import { ContactEmailType } from "@/enums/ContactEmailType";
import { error, errorApi, success } from "@/services/ToastService";
import { handleApiResponse, confirmPopup } from "@/services/Utility";
import { type ActivityLogContactAction, type ActivityLogContact } from "@/types/ActivityLog";
import type { Project } from "@/types/Projects";
import type { ApiError } from "@/types/Response";
import axios from "axios";
import { useConfirm } from "primevue/useconfirm";
import { ref } from "vue";

const confirm = useConfirm();
const validationError = ref("");
const action = ref<ActivityLogContactAction>();
const message = ref<string>("");
const sending = ref<boolean>(false);

interface Props {
  contact: ActivityLogContact;
  project: Project;
  reachedAllocatedInspections: boolean;
}
const props = defineProps<Props>();

const checkAndSendEmail = (): void => {
  sending.value = true;
  if (
    props.reachedAllocatedInspections &&
    (action.value?.emailType == ContactEmailType.REQUEST_INSPECTION_FROM_INSPECTOR ||
      action.value?.emailType == ContactEmailType.REQUEST_INSPECTION_FROM_APPRAISER)
  ) {
    confirmPopup(
      confirm,
      "Inspection Request",
      "This project has reached its allocated number of inspections. Do you wish to continue with this inspection request?",
      () => {
        sendEmail();
      },
      () => (sending.value = false)
    );
  } else {
    sendEmail();
  }
};

const sendEmail = (): void => {
  axios
    .post(
      "/activitylog/contact/" +
        props.project.projectDrawInfo.drawId +
        "?entityId=" +
        props.contact.entityId +
        "&action=" +
        action.value?.emailType +
        "&message=" +
        message.value
    )
    .then((response) => {
      handleApiResponse(
        response,
        (result: string) => {
          success("Message sent.", result);
          sending.value = false;
        },
        (errors: ApiError[]) => {
          sending.value = false;
          error("Could not send message", errors[0].message);
        }
      );
    })
    .catch((e) => errorApi(e));
};
</script>
